import { useCallback, useMemo, useReducer } from "react";

import { ExotelReduceActions } from "./actions";
import reduceExotelSettings from "./reducer";

function getInitialExotelSettings(exotelSettings) {
  return {
    apiKey: exotelSettings?.apiKey ?? "",
    apiToken: exotelSettings?.apiToken ?? "",
    accountSid: exotelSettings?.accountSid ?? "",
    subdomain: exotelSettings?.subdomain ?? "",
    voiceBotAppId: exotelSettings?.voiceBotAppId ?? "",
    phoneNumbers: exotelSettings?.phoneNumbers ?? [""],
    errors: {
      apiKey: null,
      apiToken: null,
      accountSid: null,
      subdomain: null,
      voiceBotAppId: null,
      phoneNumbers: {
        0: null,
      },
    },
  };
}

export default function useExotelStore(exotelSettings) {
  const [state, dispatch] = useReducer(
    reduceExotelSettings,
    exotelSettings,
    getInitialExotelSettings
  );

  const updateAPIKey = useCallback(function (apiKey) {
    dispatch({ type: ExotelReduceActions.UPDATE_API_KEY, payload: { apiKey } });
  }, []);

  const updateAPIToken = useCallback(function (apiToken) {
    dispatch({
      type: ExotelReduceActions.UPDATE_API_TOKEN,
      payload: { apiToken },
    });
  }, []);

  const updateAccountSid = useCallback(function (accountSid) {
    dispatch({
      type: ExotelReduceActions.UPDATE_ACCOUNT_SID,
      payload: { accountSid },
    });
  }, []);

  const updateSubdomain = useCallback(function (subdomain) {
    dispatch({
      type: ExotelReduceActions.UPDATE_SUBDOMAIN,
      payload: { subdomain },
    });
  }, []);

  const updateVoiceBotAppId = useCallback(function (voiceBotAppId) {
    dispatch({
      type: ExotelReduceActions.UPDATE_VOICE_BOT_APP_ID,
      payload: { voiceBotAppId },
    });
  }, []);

  const addPhoneNumber = useCallback(function (phoneNumber) {
    dispatch({
      type: ExotelReduceActions.ADD_PHONE_NUMBER,
    });
  }, []);

  const updatePhoneNumber = useCallback(function (phoneNumber, phoneNumberIdx) {
    dispatch({
      type: ExotelReduceActions.UPDATE_PHONE_NUMBER,
      payload: { phoneNumber, phoneNumberIdx },
    });
  }, []);

  const removePhoneNumber = useCallback(function (phoneNumberIdx) {
    dispatch({
      type: ExotelReduceActions.REMOVE_PHONE_NUMBER,
      payload: { phoneNumberIdx },
    });
  }, []);

  const updateState = useCallback(function (state) {
    dispatch({ type: ExotelReduceActions.SET_STATE, payload: getInitialExotelSettings(state) });
  }, []);

  const value = useMemo(
    function () {
      return {
        state,
        updateAPIKey,
        updateAPIToken,
        updateAccountSid,
        updateSubdomain,
        updateState,
        updateVoiceBotAppId,
        addPhoneNumber,
        removePhoneNumber,
        updatePhoneNumber,
      };
    },
    [state]
  );

  return value;
}
